import { getDeviceFreshnessTime } from "./deviceUtils";

export const DEVICE_OFFLINE_THRESHOLD_MINUTES = 1440;
export const DEVICE_OUTDATED_THRESHOLD_MS = 48 * 60 * 60 * 1000;

export function isDeviceOnlineByTime(
  freshnessTime,
  thresholdMinutes = DEVICE_OFFLINE_THRESHOLD_MINUTES
) {
  if (!freshnessTime) return false;

  const updatedAtMs = new Date(freshnessTime).getTime();
  if (Number.isNaN(updatedAtMs)) return false;

  return Date.now() - updatedAtMs <= thresholdMinutes * 60 * 1000;
}

export function isDeviceOutdatedByTime(
  freshnessTime,
  thresholdMs = DEVICE_OUTDATED_THRESHOLD_MS
) {
  if (!freshnessTime) return false;

  const updatedAtMs = new Date(freshnessTime).getTime();
  if (Number.isNaN(updatedAtMs)) return false;

  return Date.now() - updatedAtMs > thresholdMs;
}

export function isDeviceOnline(device, thresholdMinutes) {
  return isDeviceOnlineByTime(getDeviceFreshnessTime(device), thresholdMinutes);
}
